import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frame-redirect',
  templateUrl: './frame-redirect.component.html',
  styleUrls: ['./frame-redirect.component.css']
})
export class FrameRedirectComponent implements OnInit {

  constructor() { 
    console.log("AUTH: Frame-direct");
  }

  ngOnInit() {
  }

}
